<script lang="ts">
	interface Props {
		className?: string;
		stroke?: string;
	}

	let { className = '', stroke = '1' }: Props = $props();
</script>

<div class={className}>
	<svg
		viewBox="0 0 24 24"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="errorIconTitle"
		stroke="currentColor"
		stroke-width={stroke}
		stroke-linecap="square"
		stroke-linejoin="miter"
		fill="none"
		color="currentColor"
	>
		<path d="M12 8L12 13"></path>
		<line x1="12" y1="16" x2="12" y2="16"></line>
		<circle cx="12" cy="12" r="10"></circle>
	</svg>
</div>
